// File#: _1_pre-header

(function () {

	'use strict';

	const Preheader = function (element) {

		// The preheader itself
		this.element = element;

		// The close trigger
		this.trigger = element.getElementsByClassName('js-pre-header__close-btn')[0];

		this.closePreheader = this.closePreheader.bind(this);

		this.initiateListener();
	}

	/**
	 * Starts listening
	 */
	Preheader.prototype.initiateListener = function () {

		if(!this.getCookie('theme-preheader')) {
			this.trigger.addEventListener('click', this.closePreheader);

		} else {
			this.closePreheader();
		}
	}

	/**
	 * Hides the preheader
	 */
	Preheader.prototype.closePreheader = function () {

		this.element.classList.add('pre-header--hide');

		this.setCookie('theme-preheader');
	}

	/**
	 * Retrieves the value of a cookie by the given name
	 *
	 * @param name The name of the cookie to retrieve
	 *
	 * @returns {string} The cookie value
	 */
	Preheader.prototype.getCookie = function (name) {

		const cookie = '; ' + document.cookie;

		const parts = cookie.split('; ' + name + '=');

		if (parts.length === 2) {
			return parts.pop().split(';').shift();
		}
	}

	/**
	 * Sets a cookie with the specified name, expiring in one week
	 *
	 * @param name The name of the cookie to set
	 */
	Preheader.prototype.setCookie = function (name) {

		let date = new Date();
		date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000)); // Add 7 days in milliseconds

		document.cookie = name + '=true; expires=' + date.toUTCString() + '; path=/';
	}

	const preheaders = document.getElementsByClassName('js-pre-header');

	for (const preheader of preheaders) {
		new Preheader(preheader);
	}

}());